module.exports = __webpack_public_path__ + "img/ca.c9a2d731.jpg";